import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService, UserService } from '../services';
import { User } from '../models';

@Component({
  moduleId: module.id,
  selector: 'app-header',
  templateUrl: 'header.component.html',
  styleUrls: ['header.component.css']
})

export class HeaderComponent implements OnInit {
    breadcrumb: string;

    constructor(
        public authService: AuthenticationService,
        private router: Router,
        private activatedRoute: ActivatedRoute) {
    }

    ngOnInit() {
        if (this.activatedRoute && this.activatedRoute.snapshot.firstChild) {
            //      this.breadcrumb = this.activatedRoute.snapshot.firstChild.data['breadcrumb'];
        }

        this.router.events.subscribe(() => {
            if (this.activatedRoute && this.activatedRoute.snapshot.firstChild) {
                //        this.breadcrumb = this.activatedRoute.snapshot.firstChild.data['breadcrumb'];
            }
        });
    }

    isUserInRoles(expectedRoles: Array<string>): boolean {
        return expectedRoles.some(role => this.authService.isUserInRole(role));
    }

    logout(): void {
        this.authService.logout()
            .subscribe(
                () => {
                    console.log('logout');
                    localStorage.removeItem("access_token");
                    this.router.navigate(['/'])
                },
                () => {
                    console.log('logout 2');
                    localStorage.removeItem("access_token");
                    this.router.navigate(['/'])
                }
        );
    }
}
